import React from "react";
import { Box, Flex } from "orcs-design-system";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { AISummary } from "../AIContent/AISummary";
import { SOURCE_TYPES } from "../AIContent/consts";

export const AIPanel = () => {
  const { enableAIElevatorPitchOnUserDashboard } = useWorkspaceFeatureFlags();

  if (!enableAIElevatorPitchOnUserDashboard) {
    return null;
  }

  return (
    <Box bg="white" boxBorder="default" borderRadius={2}>
      <Flex flexDirection="column" justifyContent="space-between" p="s">
        <AISummary
          sourceId={SOURCE_TYPES.personal_elevator_pitch}
          subjectId="user_id"
        />
      </Flex>
    </Box>
  );
};
